import { render, staticRenderFns } from "./NetworkMain.vue?vue&type=template&id=babbd458&scoped=true&"
import script from "./NetworkMain.vue?vue&type=script&lang=js&"
export * from "./NetworkMain.vue?vue&type=script&lang=js&"
import style0 from "./NetworkMain.vue?vue&type=style&index=0&id=babbd458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babbd458",
  null
  
)

component.options.__file = "NetworkMain.vue"
export default component.exports